import { ChangeDetectorRef, Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AssessmentService } from '../../services/assesment.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '../../services/authentication.service';
import { User } from '../../models/auth';
import { Patterns } from '../../../helpers/patterns';
import { Location } from '@angular/common';

@Component({
  selector: 'app-assesment',
  standalone: false,
  templateUrl: './assesment.component.html'
})
export class AssesmentComponent {

  lang = localStorage.getItem('language') || 'ar';
  languageView = true;
  preStartView = false;
  startView = false;
  resultView = false;
  stepIndex = 1;
  progressValue: number = 0;
  currentQuestionIndex = 1;
  bufferValue = 0;
  iconPosition: string = '0px';

  @ViewChild('progressBar', { static: false }) progressBar!: ElementRef;


  currentTestId: string = '8229065e-f280-4939-8ab9-2a86323163c0';
  isDefault = true;

  questions: any[] = [];
  dataLoading = false;

  selectedLang: any;
  currentSystemLang: any;

  total = 0;
  remain = 100;

  loading = false;
  resultInfo!: any;
  skipLoading = false;

  numberPattern = Patterns.percentageTwoDigits;

  languages: any[] = [
    {
      name: 'general.Arabic',
      id: 'ar',
      img: '/assets/images/login/arabic-lang.svg'
    },
    {
      name: 'general.English',
      id: 'en',
      img: '/assets/images/login/english-lang.svg'
    },
  ]

  constructor(
    private router: Router,
    private assessmentService: AssessmentService,
    private activeRout: ActivatedRoute,
    private authService: AuthenticationService,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
    public location: Location
  ) { }

  ngOnInit(): void {
    this.currentSystemLang = localStorage.getItem('language');
    this.selectedLang = localStorage.getItem('language');
    this.activeRout.paramMap.subscribe(params => {
      if (params.get('id')) {
        this.currentTestId = params.get('id') || '';
        this.isDefault = false;
      }
    })
    // this.navigateUser();
  }

  ngAfterViewInit() {
    // this.updateIconPosition();
  }

  navigateUser(user: User | null = this.authService.currentUserValue) {
    if (user && this.isDefault) {
      if (user.complete_personality_test) {
        this.router.navigateByUrl('/auth/profile');
      }
    }
  }

  @HostListener('window:resize') onResize() {
    this.updateIconPosition();
  }

  onChooseLanguage(selectedLang: any) {
    const oldLanguage: any = localStorage.getItem('language');
    localStorage.setItem('systemLang', oldLanguage);
    
    this.selectedLang = selectedLang.id;
    localStorage.setItem('language', this.selectedLang);
    window.location.reload();
  }

  getTestQuestions() {
    this.dataLoading = true;
    this.assessmentService.getTestQuestions(this.currentTestId).subscribe((res) => {
      this.questions = res.data;
      this.bufferValue = this.questions.length;
      this.progressValue = ((this.currentQuestionIndex) / this.bufferValue) * 100;
      this.dataLoading = false;
      setTimeout(() => {
        this.updateIconPosition();
      }, 10);
    })
  }

  calculateRemaining() {
    this.questions[this.currentQuestionIndex - 1].valid = false;
    this.questions[this.currentQuestionIndex - 1].total = this.questions[this.currentQuestionIndex - 1].anwsers.map((q: any) => Number(q.percentage || 0)).reduce((acc: number, cur: number) => acc + cur, 0);
    if (this.questions[this.currentQuestionIndex - 1].total == 100 && !this.isDuplicatePercentage(this.currentQuestionIndex - 1)) {
      this.questions[this.currentQuestionIndex - 1].valid = true;
    } else {
      this.questions[this.currentQuestionIndex - 1].valid = false;
    }
  }

  // hasError(index: number) {
  //   let hasInvalidPattern = this.questions[index - 1].anwsers.every((a: any) => !/^[0-9]+$/.test(String(a.percentage)));

  //   if (this.questions[index - 1].anwsers.every((a: any) => a.percentage) && this.questions[index - 1]?.total < 100) {
  //     return this.questions[index - 1]?.total > 100 || this.questions[index - 1]?.total < 100 || hasInvalidPattern;
  //   } else if (this.questions[index - 1].anwsers.every((a: any) => a.percentage) && this.questions[index - 1]?.total > 100) {
  //     return this.questions[index - 1]?.total > 100 || this.questions[index - 1]?.total < 100
  //   }
  //   return false;
  // }

  hasError(index: number): boolean {
    const question = this.questions[index - 1];
    if (!question) return false;
  
    const answers = question.anwsers || [];
    const total = question.total || 0;
  
    // Check if any percentage has invalid characters
    const hasInvalidPattern = answers.some((a: any) => !/^[0-9]+$/.test(String(a.percentage)));
  
    // Check if total is not exactly 100
    const invalidTotal = total !== 100;
  
    return hasInvalidPattern || invalidTotal;
  }
  

  isDuplicatePercentage(index: number): boolean {
    const question = this.questions[index - 1];
    if (!question) return false;

    const percentages = question.anwsers
      .map((a: any) => a.percentage)
      .filter((p: any) => p !== undefined && p !== null); // Remove empty values

    return percentages.some((value: any, idx: any, arr: any) => arr.indexOf(value) !== idx);
  }

  preventSpecialChars(event: KeyboardEvent) {
    const invalidChars = ['+', '-', '.', '$', '#', '@'];

    if (invalidChars.includes(event.key)) {
      event.preventDefault();
    }
  }

  isInvalidPercentage(index: number): boolean {
    const question = this.questions[index - 1];
    if (!question) return false;

    const percentages = question.anwsers
      .map((a: any) => a.percentage)
      .filter((p: any) => p !== undefined && p !== null); // Remove empty values

    return !percentages.some((value: any, idx: any) => /^[0-9]+$/.test(value) !== idx);
  }


  skipTest() {
    this.backToCurrentSystemLang();
    this.location.back();
    // if (this.isDefault) {
    //   this.skipLoading = true;
    //   this.backToCurrentSystemLang();
    //   this.assessmentService.skipTest().subscribe((res) => {
    //     this.router.navigate(['/auth/profile'], { queryParams: { main: 1, child: 0 } })
    //   })
    // } else {
    //   // this.router.navigateByUrl('/auth/profile');
    //   this.router.navigate(['/auth/profile'], { queryParams: { main: 1, child: 0 } }).then(() => {
    //     this.backToCurrentSystemLang();
    //   });
    // }
    
    // this.router.navigate(['/auth/profile'], { queryParams: { main: 1, child: 0 } }).then(() => {
    //   this.backToCurrentSystemLang();
    // });
  }

  startTest() {
    this.stepIndex++;
    this.getTestQuestions();
    this.updateIconPosition();
  }

  nextStep() {
    if (this.selectedLang) {
      localStorage.setItem('language', this.selectedLang);
      window.location.reload();
      localStorage.setItem('step', '2');
    }
  }

  validateQuestion() {
    let question = this.questions[this.currentQuestionIndex - 1];
    let allHasValue = question.anwsers.every((a: any) => {
      const percentage = a.percentage;
      const isNotEmpty = percentage !== undefined && percentage !== null && percentage !== '';
      const isInteger = /^[0-9]+$/.test(percentage);
      return isNotEmpty && isInteger;
    });
    return question?.valid && allHasValue && !this.isDuplicatePercentage(this.currentQuestionIndex);
  }


  nextQuestion() {
    if (this.currentQuestionIndex < this.questions.length) {
      this.currentQuestionIndex++;
      this.progressValue = ((this.currentQuestionIndex) / this.bufferValue) * 100;
    } else {
      this.stepIndex++;
      this.storeAnswers();
    }
    this.updateIconPosition();
  }

  prevQuestion() {
    if (this.currentQuestionIndex > 1) {
      this.currentQuestionIndex--;
      this.progressValue = ((this.currentQuestionIndex) / this.bufferValue) * 100;
    } else if (this.currentQuestionIndex == 1) {
      this.stepIndex--;
    }
    this.updateIconPosition();
  }

  storeAnswers() {
    let data = {
      test_id: this.currentTestId,
      questions: this.questions
    }
    this.loading = true;
    this.assessmentService.saveTestAnswers(data).subscribe((res) => {
      this.loading = false;
      this.resultInfo = res.data;
    })
  }

  getResultPdf() {
    window.open(this.resultInfo.pdf, '_blank');
    this.router.navigate(['/auth/profile'], { queryParams: { main: 1, child: 0 } }).then(() => {
      this.backToCurrentSystemLang();
    });
  }

  skipResult() {
    // this.router.navigateByUrl('/auth/profile');
    this.router.navigate(['/auth/profile'], { queryParams: { main: 1, child: 0 } }).then(() => {
      this.backToCurrentSystemLang();
    });
  }

  updateIconPosition() {
    if (!this.progressBar?.nativeElement) return;

    let progressBarWidth = this.progressBar.nativeElement.clientWidth;
    let percentage = this.progressValue / 100;
    let position = progressBarWidth * percentage;
    let iconWidth = 24;
    this.iconPosition = `${Math.max(0, Math.min(position - iconWidth / 2, progressBarWidth - iconWidth))}px`;

    // if (this.lang == 'en') {
    //   this.iconPosition = `${Math.max(0, Math.min(progressBarWidth - position - iconWidth / 10, progressBarWidth - iconWidth))}px`;
    // } else {
    //   this.iconPosition = `${Math.max(0, Math.min(position - iconWidth / 2, progressBarWidth - iconWidth))}px`;
    // }
  }

  backToCurrentSystemLang() {
    let originalLang: any = localStorage.getItem('systemLang') || localStorage.getItem('language');
    localStorage.setItem('language', originalLang);
    this.updateLanguageStyles(originalLang);
  }

  updateLanguageStyles(lang: string) {
    localStorage.setItem('language', lang);
    localStorage.removeItem('systemLang');
    this.translate.use(lang).subscribe(() => {
      window.location.reload();
      this.cdr.detectChanges();
    })

    let style = 'assets/css/ar/style.css';
    let dir = 'rtl';
    if (lang === 'en') {
      style = 'assets/css/en/style.css';
      dir = 'ltr';
    }

    document.getElementById('mainStyle')?.setAttribute('href', style);
    document.getElementById('html')?.setAttribute('lang', lang);
    document.getElementById('html')?.setAttribute('dir', dir);
  }


}
